var CryptoJS = require("crypto-js");
const md5 = require('md5');

export function generateVodTicket() {

  //#region generate ticket
  let salt = 'uploadvideo'
  let ticket = md5(`${Date.now()}${salt}`) 
  //#endregion
  let data = {
    ticket
  };

  //#endregion
  console.log(data)
  //#region encrypt data
  let jsonData = JSON.stringify(data);
  let secret = "z2TzBphyfpMUJe4e";
  let encrypted = CryptoJS.AES.encrypt(jsonData, secret);
  let encryptedData = encrypted.toString();
  //#endregion
  
  return encryptedData
}